import(/* webpackMode: "eager" */ "/workspace/web/app/globals.css");
;
import(/* webpackMode: "eager" */ "/workspace/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/web/platform/auth/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginProvider"] */ "/workspace/web/platform/auth/LoginContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecaptchaEnterpriseTelemetry"] */ "/workspace/web/platform/auth/RecaptchaEnterpriseTelemetry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentShell"] */ "/workspace/web/platform/cookies/CookieConsentShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TermsGate"] */ "/workspace/web/platform/legal/TermsGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeployChunkRecovery"] */ "/workspace/web/platform/lib/DeployChunkRecovery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FirebaseAnalytics"] */ "/workspace/web/platform/lib/FirebaseAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OpsITSMShell"] */ "/workspace/web/platform/servicedesk/OpsITSMShell.tsx");
